import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, ReactElement } from 'react';

import type { ModalBodyProps } from './modal-body.types';

import './modal-body.scss';

/**
 * Modal body component is used to render the body section of the modal dialog.
 * Use the `padding` prop to control the padding of the body section, the default is `narrow`.
 */
const ModalBody = forwardRef(
  (props: ModalBodyProps, forwardedRef: ForwardedRef<HTMLDivElement> | null): ReactElement => {
    const { children, className, padding = 'narrow', ...rest } = props;

    return (
      <div {...rest} className={cn('rbui-modal__body', `rbui-modal__body--${padding}`, className)} ref={forwardedRef}>
        {children}
      </div>
    );
  },
);

ModalBody.displayName = 'ModalBody';

export default ModalBody;
